interface Props {
  /** Position: bottom of hero, or full panel */
  position?: "bottom" | "panel";
  /** Color theme */
  tone?: "light" | "dark";
  className?: string;
}

/**
 * Three-layer parallax ocean waves rendered as repeating SVG paths.
 * Designed to sit at the bottom of a hero section.
 */
export function AnimatedWaves({ position = "bottom", tone = "light", className = "" }: Props) {
  const fills =
    tone === "light"
      ? ["rgba(255,255,255,0.18)", "rgba(255,255,255,0.30)", "rgba(255,255,255,0.95)"]
      : ["rgba(30,77,107,0.15)", "rgba(30,77,107,0.30)", "rgba(30,77,107,0.85)"];

  return (
    <div className={`pointer-events-none ${position === "bottom" ? "absolute bottom-0 left-0 right-0" : ""} ${className}`} aria-hidden="true">
      <svg
        viewBox="0 0 2880 200"
        preserveAspectRatio="none"
        className="w-full h-24 md:h-32"
      >
        <defs>
          <path
            id="wavePath"
            d="M 0 100
               C 240 60, 480 140, 720 100
               C 960 60, 1200 140, 1440 100
               C 1680 60, 1920 140, 2160 100
               C 2400 60, 2640 140, 2880 100
               L 2880 200 L 0 200 Z"
          />
          <path
            id="wavePath2"
            d="M 0 120
               C 240 80, 480 160, 720 120
               C 960 80, 1200 160, 1440 120
               C 1680 80, 1920 160, 2160 120
               C 2400 80, 2640 160, 2880 120
               L 2880 200 L 0 200 Z"
          />
        </defs>

        {/* Back layer — slowest */}
        <g className="animate-wave-slower">
          <use href="#wavePath" fill={fills[0]} />
          <use href="#wavePath" fill={fills[0]} x="2880" />
        </g>

        {/* Mid layer */}
        <g className="animate-wave-slow">
          <use href="#wavePath2" fill={fills[1]} />
          <use href="#wavePath2" fill={fills[1]} x="2880" />
        </g>

        {/* Front layer — solid */}
        <g>
          <path
            d="M 0 150
               C 240 130, 480 170, 720 150
               C 960 130, 1200 170, 1440 150
               C 1680 130, 1920 170, 2160 150
               C 2400 130, 2640 170, 2880 150
               L 2880 200 L 0 200 Z"
            fill={fills[2]}
          />
        </g>
      </svg>
    </div>
  );
}
